import { api } from "../../services/api/index"
import React, { useRef, useState } from "react"
import { useEffect } from "react"
import "./GuessWordView.scss"

const GuessWordView = () => {
  const guesses_limit = 6
  const [words, setWords] = useState([])
  const [newWord, setNewWord] = useState("")
  const [count, setCount] = useState(0)
  const [encontroPalabra, setEncontroPalabra] = useState(false)
  const [category, setCategory] = useState("")
  const [word, setWord] = useState("")
  const [clue, setClue] = useState("")
  const [finDelJuego, setFinDelJuego] = useState(false)
  const [alertaUltimaOportunidad, setAlertaUltimaOportunidad] = useState(false)

  useEffect(() => {
    if (category === "") return
    var { url, opt } = api.games.GuessWord.generate({
      difficulty: "easy",
      type: category,
    })
    console.log("URL OPT ->", url, opt)
    fetch(url, opt)
      .then((res) => res.json())
      .then((res) => {
        console.log("RESULT", res)
        console.log("RESULT", res.word)
        console.log("RESULT", res.clue)

        setWord(res.word.toLowerCase())
        setClue(res.clue)

        console.log("CURRENTSSS", res.word, res.clue)
      })
  }, [category])

  const getWrdEmbedingSimilarity = (guess) => {
    if (guess === word) {
      console.log("ENCONTRO LA PALABRA LOCO", word, guess)
      setEncontroPalabra(true)
      return 10000
    } else {
      console.log("word", word)
      const { url, opt } = api.games.GuessWord.get_similarity(word, guess)

      return fetch(url, opt)
        .then((res) => res.json())
        .then((res) => {
          console.log("DISTANCIA", res.distance)
          return res.distance
        })
    }
  }

  const embeddingDistancesCriteria = (a, b) => {
    return a.embeddingSimilarity > b.embeddingSimilarity
      ? -1
      : a.embeddingSimilarity < b.embeddingSimilarity
      ? 1
      : 0
  }

  // Función para manejar el input
  const handleInputChange = (e) => {
    setNewWord(e.target.value)
  }

  const handleAddWord = async (e) => {
    e.preventDefault() // Previene que el formulario recargue la página
    if (newWord.trim() === "") return // Evita agregar palabras vacías

    if (count + 1 === guesses_limit) {
      setFinDelJuego(true)
    } else if (count + 2 === guesses_limit) {
      setAlertaUltimaOportunidad(true)
    }

    setCount(count + 1)

    // Espera a que se resuelva la similitud
    const similarity = await getWrdEmbedingSimilarity(newWord.toLowerCase())
    console.log("SIMILARITY", similarity)

    // Agrega la nueva palabra a la lista y ordena
    const updatedWords = [
      ...words,
      { index: count, value: newWord, embeddingSimilarity: similarity },
    ].sort(embeddingDistancesCriteria)
    console.log("UPDATED WORDS", updatedWords)

    setWords(updatedWords)
    setNewWord("") // Limpiar el campo de entrada
  }

  if (category === "") {
    return (
      <div>
        <div className="app-container">
          <h1>Choose a category</h1>
        </div>

        <div className="category-container">
          <button
            className="category-button"
            onClick={() => setCategory("Animals")}>
            Animals
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Family")}>
            Family
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Colors")}>
            Colors
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Foods")}>
            Foods
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Calendar")}>
            Calendar
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("House")}>
            House
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Sports")}>
            Sports
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Body")}>
            Body
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Weather")}>
            Weather
          </button>
          <button
            className="category-button"
            onClick={() => setCategory("Numbers")}>
            Numbers
          </button>
        </div>
      </div>
    )
  }

  if (!encontroPalabra && !finDelJuego) {
    return (
      <div>
        <div
          className="app-container"
          style={
            alertaUltimaOportunidad
              ? { backgroundColor: "#fa4" }
              : { backgroundColor: "#4d40be" }
          }>
          <h1>Lista de palabras por cercania</h1>
          {alertaUltimaOportunidad && <h2>Ultima oportunidad!!</h2>}
          <p className="clue">Clue: {clue}</p>
          <form className="formulario-guess" onSubmit={handleAddWord}>
            <input
              type="text"
              value={newWord}
              onChange={handleInputChange}
              placeholder="Guess the word!"
              className="input-field"
            />
            <button type="submit" className="add-button">
              Agregar
            </button>
          </form>
        </div>
        <div className="word-container">
          {words.length > 0 && (
            <ol className="word-list">
              {words.map((word) => (
                <li key={word.index} className="word-item">
                  {word.value}
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    )
  }

  if (finDelJuego) {
    return (
      <div>
        <div className="word-and-clue-container">
          <div className="card">The clue was "{clue}"</div>
          <div className="card">The word was "{word}"</div>
        </div>
        <div className="card">
          <div className="card-header">You almost did it! Try again!</div>
        </div>
        <div className="btn-container">
          <a className="btnn" href="/guessword">
            Play again
          </a>
          <a className="btnn" href="/">
            Play other games
          </a>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="card">
        <div className="card-header">¡Felicidades!</div>
      </div>
      <div className="btn-container">
        <a className="btnn" href="/guessword">
          Volver a jugar
        </a>
        <a className="btnn" href="/">
          Volver a juegos
        </a>
      </div>
    </div>
  )
}

export default GuessWordView
